import { render, staticRenderFns } from "./SalariePrintReportPotvrdaOPlaci.vue?vue&type=template&id=25f6f07c&scoped=true"
import script from "./SalariePrintReportPotvrdaOPlaci.vue?vue&type=script&lang=js"
export * from "./SalariePrintReportPotvrdaOPlaci.vue?vue&type=script&lang=js"
import style0 from "./SalariePrintReportPotvrdaOPlaci.vue?vue&type=style&index=0&id=25f6f07c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f6f07c",
  null
  
)

export default component.exports